import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { FiCheck } from "react-icons/fi";
import { useHistory } from "react-router-dom";

import { PRIVATE_ROUTES } from "../../../../constants";
import ConfirmationModal from "../../../Dialogs/ConfirmationModal";
import { Color } from "../../../Form/Button";
import useStyles from "./styles";

export interface CreateShipmentConfirmationModalHandles {
  open: () => void;
  close: () => void;
}
interface CreateShipmentConfirmationModalProps {
  closeModal?: () => void;
  loadingAction?: boolean;
}

const CreateShipmentConfirmationModal: ForwardRefRenderFunction<
  CreateShipmentConfirmationModalHandles,
  CreateShipmentConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction } = props;
  const history = useHistory();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const open = useCallback(() => {
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const goBackToList = () => {
    history.push(PRIVATE_ROUTES.SHIPMENTS);
  };

  return (
    <ConfirmationModal
      width="520px !important"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
        goBackToList();
      }}
      type="success"
      title={translate("shipmentCreated")}
      leftIconTitle={<FiCheck color={colors.success500} size={20} />}
      loading={loadingAction}
      customColorSave={Color.SUCCESS}
      textSubmit={translate("close")}
      showCancelButton={false}
      submit={() => goBackToList()}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.cancelModalContainer}>
          <div data-cy="confirmationModalCancelBody" className={classes.descriptionModalConfirm}>
            <span>
              {`${translate(
                "yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable"
              )}
            ${translate(
              "inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid"
            )}
            `}
            </span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(CreateShipmentConfirmationModal);
